import Flickity from "flickity";
import closeModalX from './modals';

retrieveModals();

export default function retrieveModals() {
  let modalBtns = document.querySelectorAll("[data-modal='show-modal']");

  for (let i = 0; i < modalBtns.length; i++) {
    const modalHref = modalBtns[i].dataset.modalHref;
    const modalID = modalBtns[i].dataset.modalId;
    const modalType = modalBtns[i].dataset.modalType;

    modalBtns[i].addEventListener("click", function(e) {
      if (window.innerWidth > 992 && modalType === "case-preview") {
        e.preventDefault();
      }
      getModal(modalID, modalHref, modalType);
    });
  }
}

function getModal(mID, mHref, mType) {
  const getModalID = mID;
  const request = new XMLHttpRequest();
  if (mType === "storelocator") {
    request.open(
      "GET",
      "/find-forhandler/forhandlere.aspx?layouttemplate=modal-storelocator.cshtml&storeID=" +
        mID +
        "",
      true
    );
    
  } else {
    request.open("GET", mHref, true);
  }
  if (mType !== "video") {
    request.onload = function() {
      var tds;
      if (request.status >= 200 && request.status < 400) {
        var resp = request.responseText;
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(resp, "text/html");
        if (mID && mType === "storelocator") {
          tds = xmlDoc.querySelector(".modal-storelocator");
        }
        if (mType !== "video" && mType !== "storelocator") {
          tds = xmlDoc.querySelector(".modals");
        }
        tds.classList.add("open");
        tds.querySelector(".modal-dialog").classList.add("open");
        document.body.appendChild(tds);
        

        // If modal contains a gallery
        var modalElem = document.querySelector(".modal-carousel");
        if (modalElem) {
          var flktyModal = new Flickity(modalElem, {
            // options
            cellAlign: "left",
            freeScroll: true,
            wrapAround: true,
            pageDots: false,
            imagesLoaded: true
          });
        }
        
      } else {
        console.log("Error", request.status);
      }
    };

    request.onerror = function() {};

    request.send();
  }
}





// WEBPACK FOOTER //
// ./scripts/components/ajax-modals.js